<span class="kt-badge kt-badge--danger kt-badge--inline" *ngIf="status === 1">Not Started</span>
<span class="kt-badge kt-badge--primary kt-badge--inline" *ngIf="status === 2">In Progress</span>
<span class="kt-badge kt-badge--warning kt-badge--inline" *ngIf="status === 3">On Hold</span>
<span class="kt-badge kt-badge--success kt-badge--inline" *ngIf="status === 4">Closed</span>